export default __webpack_public_path__ + "static/media/content.da6cb697.txt";